<template>
  <div
    class="card-program"
    @click="handleClick"
  >
    <div class="overlay-container card-left">
      <img
        :src="programData.avatar && !isBrokenImage ? `${urlServerImage}/303x202,fit/${programData.avatar}` : defaultImage"
        :alt="`${programData.name} | Sekolah.mu`"
        @error="isBrokenImage = true"
        class="card-image"
        loading="lazy"
        width="160"
        height="105"
        :class="{'overlay-image': (programData.group.length && !programData.is_joined) || (programData.max_quota && !programData.current_quota)}"
      >
      <div
        class="overlay"
        v-if="(programData.group.length && !programData.is_joined) || (programData.max_quota && !programData.current_quota)"
      >
        <div class="overlay-text open-sans font-weight-bold">
          {{programData.max_quota && !programData.current_quota ? 'KUOTA HABIS' : 'TERBATAS'}}
        </div>
      </div>
    </div>
    <div class="card-right">
      <div class="informasi">
        <div class="card-title">
          {{programData.name}}
        </div>
        <div class="creator-title">
          Oleh <span class="creator-name">{{programData.creator ? programData.creator : 'Sekolahmu'}}</span>
        </div>
        <div class="rating">
          <s-rating :length="5" :modelValue="ratingProgram" size="medium" />
          <span class="rating-number">
            {{ ratingProgram }}
          </span>
          <span class="reviewers">
            {{ `(${reviewersProgram})` }}
          </span>
        </div>
      </div>
      <div class="program-price">
        <div
          class="discounted-price"
          v-if="programData.group.length"
        >Terbatas</div>
        <div
          class="discounted-price-ikut"
          v-else-if="programData.enrolled && isLogin"
        >Sudah Ikut</div>
        <div
          class="d-flex"
          v-else
        >
          <div class="discounted-price">{{rupiahFormatDiscount(programData.price)}}</div>
          <div class="normal-price">{{rupiahFormatNormal(programData.price_normal)}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import rupiah from '../../functions/rupiah'
import Image from '../../assets/images/programmu/index'
export default {
  name: 'program-card-mobile',
  data () {
    return {
      defaultImage: Image.no_cover,
      isBrokenImage: false
    }
  },
  props: {
    programData: Object
  },
  computed: {
    urlServerImage () {
      return process.env.VUE_APP_URL_SERVER_IMAGE
    },
    ratingProgram () {
      return Number(this.programData.rating || 0)
    },
    reviewersProgram () {
      return Number(this.programData.reviewers || 0)
    },
    isLogin () {
      return this.$store.state.user.isLogin
    }
  },
  methods: {
    // validateProgram () {
      // if (this.programData.group.length && !this.programData.is_joined) {
      //   let selected = null
      //   if ((this.programData.slug || this.programData.id) && this.programData.group.length && this.programData.is_joined) {
      //     selected = this.programData.slug || this.programData.id
      //   }

      //   this.$store.commit('program/CHANGE_OPEN_PROGRAM_TERBATAS', { isOpen: true, selected })
      // }
    // },
    handleClick () {
      // this.validateProgram() // validate program
      const route = this.toDetail(this.programData.slug ? this.programData.slug : this.programData.id)
      this.$router.push(route)
    },
    toDetail (id) {
      // DEFINE REFERAL
      let pageRef
      if (this.$route.params.project) {
        pageRef = this.$route.params.project ? this.$route.params.project : ''
      } else if (this.$route.params.institution_slug) {
        pageRef = this.$route.params.institution_slug ? this.$route.params.institution_slug : ''
      } else {
        pageRef = ''
      }

      const queryRef = this.$route.query.ref ? this.$route.query.ref : ''

      if (pageRef && queryRef) {
        return `/program/${id}?ref=${pageRef}_${queryRef}`
      } else if (pageRef) {
        return `/program/${id}?ref=${pageRef}`
      } else {
        return `/program/${id}`
      }
    },
    rupiahFormatDiscount (nominal) {
      if (Number(nominal) === 0) {
        return 'GRATIS'
      } else if (Number(nominal) === 0 && Number(this.programData.price_normal) !== 0) {
        return rupiah(Number(nominal))
      } else {
        return rupiah(Number(nominal))
      }
    },
    rupiahFormatNormal (nominal) {
      if (Number(nominal) === 0 && Number(this.programData.price) >= 0) {
        return ''
      } else {
        return rupiah(Number(nominal))
      }
    }
  },
  created () {
    // if (!this.programData.rating) {
    //   this.programData.rating = 0
    // } else {
    //   this.programData.rating = Number(this.programData.rating)
    // }
    // if (!this.programData.reviewers) {
    //   this.programData.reviewers = 0
    // } else {
    //   this.programData.reviewers = Number(this.programData.reviewers)
    // }
    // console.log(this.programData);
  }
}
</script>
<style scoped>
a {
  text-decoration: none;
  color: inherit;
}
.overlay-image {
  display: block;
  width: 100%;
  height: auto;
}
.overlay-container {
  position: relative;
}

.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.39);
  border-radius: 5px 5px 0 0;
}

.overlay-text {
  width: 100%;
  font-size: 20px;
  line-height: 14px;
  align-items: center;
  color: #ffffff;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  text-align: center;
}

.card-program {
  min-width: 160px;
  max-width: 160px;
  background: var(--color-neutral-100);
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  position: relative;
  display: flex;
  flex-direction: column;
  margin-top: 7px;
  margin-left: 7px;
  margin-right: 7px;
  border-radius: 10px;
  transition: 0.2s;
  cursor: pointer;
  text-decoration: none;
  color: inherit;
}
.card-left {
  min-width: 160px;
  max-width: 160px;
  min-height: 105px;
  max-height: 105px;
  overflow: hidden;
}
.card-image {
  min-width: 160px;
  max-width: 160px;
  min-height: 105px;
  max-height: 120px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.card-title {
  margin-top: 5px;
  margin-bottom: 0;
  font-weight: bold;
  font-size: 14px;
  min-height: 47px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.card-right {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  margin: 8px 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.creator-title {
  margin: 0;
  min-height: 40px;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.5);
  margin-top: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.creator-name {
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  color: #828282;
}
.rating {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.rating-number,
.reviewers {
  font-size: 13px;
  height: 13px;
  margin-left: 3px;
  color: #828282;
}
.program-price {
  display: flex;
  align-items: flex-end;
  margin-top: 8px;
}

.discounted-price {
  color: #3498db;
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;
}

.discounted-price-ikut {
  color: #ffc429;
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;
}

.normal-price {
  margin-left: 4px;
  font-size: 10px;
  color: rgba(0, 0, 0, 0.3);
  text-decoration-line: line-through;
}

@media screen and (max-width: 348px) {
  .card-program {
    margin: 5px 5px;
    min-width: 140px;
    max-width: 140px;
  }

  .card-left {
    min-width: 140px;
    max-width: 140px;
    min-height: 105px;
    max-height: 105px;
    overflow: hidden;
  }

  .card-image {
    min-width: 140px;
    max-width: 140px;
    min-height: 105px;
    max-height: 105px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
}
</style>
